import { render, staticRenderFns } from "./ComponentDetailsModal.vue?vue&type=template&id=760b91f4&scoped=true&"
import script from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetailsModal.vue?vue&type=style&index=0&id=760b91f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b91f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760b91f4')) {
      api.createRecord('760b91f4', component.options)
    } else {
      api.reload('760b91f4', component.options)
    }
    module.hot.accept("./ComponentDetailsModal.vue?vue&type=template&id=760b91f4&scoped=true&", function () {
      api.rerender('760b91f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ComponentDetailsModal.vue"
export default component.exports